import {useContext} from 'react'
import {EnterpriseEditionContext} from "../context/EnterpriseEditionContextProvider";

export function useEnterpriseEditionContext()
{
    const context = useContext(EnterpriseEditionContext);

    if (!context) {
        throw new Error(
            "useEnterpriseEditionContext must be used within the scope of EnterpriseEditionContextProvider"
        );
    }

    return context;
}